import querystring from 'query-string'

import { UrlSearchParamsMapper } from '../../../hooks/useSearchParams'

/**
 * Mapper for genre essentials search params. Only conventionalGenreId is managed by the page
 * itself, but mapToUrl spreads the browser's current query so that sibling parameters written
 * by embedded components (e.g. the update impacts table's updateTags) are preserved when the
 * page rewrites its own parameter. (GR-1335)
 */

export type GenreEssentialSearchParams = {
  conventionalGenreId?: string
  [param: string]: string | number | (string | number | undefined)[] | null | undefined
}

export type GenreEssentialFilters = {
  conventionalGenreId?: string
}

const mapUrlSearchParamsToFilters = (search: GenreEssentialSearchParams): GenreEssentialFilters => {
  return {
    conventionalGenreId: search.conventionalGenreId,
  }
}

const mapFiltersToUrlSearchParams = (filters: GenreEssentialFilters): GenreEssentialSearchParams => {
  const defaultSearch = querystring.parse(window.location.search)

  return {
    ...defaultSearch,
    conventionalGenreId: filters.conventionalGenreId,
  }
}

export const mapper: UrlSearchParamsMapper<GenreEssentialSearchParams, GenreEssentialFilters> = {
  mapFromUrl: mapUrlSearchParamsToFilters,
  mapToUrl: mapFiltersToUrlSearchParams,
}
